import * as React from 'react';
import { generatePath, useHistory } from 'react-router';

import appUrls from 'base/app/urls';
import { PK } from 'common/types';

import { fields, NutritionalValuesFields } from './consts';
import { useNutritionalValuesCreate, useNutritionalValuesUpdate } from './queries';

export const useSave = (pk?: PK) => {
  const [created, setCreated] = React.useState(pk);
  const create = useNutritionalValuesCreate();
  const update = useNutritionalValuesUpdate();
  const history = useHistory();

  const isSaving = create.isLoading || update.isLoading;
  const error = create.error || update.error;

  const save = (values: NutritionalValuesFields) => {
    const payload = {
      name: values[fields.name.name],
      unit_pk: values[fields.unit.name][0].value,
    };

    if (created) {
      update.mutate({
        ...payload,
        pk: created,
      });
    } else {
      create.mutate(payload, {
        onSuccess: ({ pk }) => {
          setCreated(pk);
          history.push(generatePath(appUrls.NUTRITIONAL_VALUES.DETAILS, { pk }));
        },
      });
    }
  };

  return { save, created, isSaving, error };
};
